import { Savings } from "./types";

// A loss has no gross figure, so it falls back to the net loss.
export const headlineInterestOf = (
  totals: Pick<Savings, "grossInterest" | "earnedValue">,
): number => totals.grossInterest ?? totals.earnedValue;
